import React from 'react';

export const ReadableNote = ({ children, testId, className = '' }) => children ? (
  <p data-testid={testId} className={`w-full min-w-0 whitespace-pre-wrap [overflow-wrap:anywhere] text-sm text-zinc-300 ${className}`}>{children}</p>
) : null;